import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsButtonComponent } from './button.model';

@Component({
  selector: 'sd-cms-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonComponent {
  constructor(public component: CmsComponentData<CmsButtonComponent>) {}
}
